import React from 'react';
import { Route, Link, Switch } from 'react-router-dom';
import { Card, Form, Button, Divider, message, Row, Col,Progress,Steps } from 'antd';
import styles from "../index.css";
import {createUuid, hasAuth} from "../../../utils/NHCore";
import Jxfzcmxx from '../steps/jxfzcmxx';
import defaultPortrait from "../../../styles/images/stuDefault.png";
import Common from "../steps/common";
import PropTypes from 'prop-types';
import createHashHistory from 'history/createHashHistory';
import numeral from 'numeral';


const Step = Steps.Step;
const hashHistory = createHashHistory();
class AutoHandleFormPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            editable:true,
        }
    }

    componentDidMount(){
    }

    render() {
        const { studentData,hjblztData,lchjData,loading,lcpz,location} = this.props;
        const { lcdyVO, } = lcpz;

        //流程统计数据
        const cardTitle = (
            <div>
                <span>{lcdyVO ? lcdyVO.lcmc : '流程'}</span>&nbsp;&nbsp;
                {/*<Progress type="circle" percent={Number(numeral(bdrs / zrs * 100).format('0'))} width={30} />&nbsp;&nbsp;*/}
                {/*<span style={{ fontWeight: 'normal', fontSize: 14 }}>报到人数 <b>{bdrs}</b> / 总人数 {zrs}</span>*/}
            </div>
        )

        const steps = (
            <Steps type="navigation" >
                <Step
                    key={lchjData.hjid}
                    status={hjblztData.blzt == '1' ? 'finish' : 'wait'}
                    title={lchjData.hjmc}
                    // description={<span><b>{item.blrs}</b>/{item.lcrs}</span>}
                />
            </Steps>
        );

        let formItems = [];
        let formItem = (<span>暂无需要填写的业务项信息</span>);
        formItems.push(formItem);

        return (
            <div className={styles.process_content}>
                <Card
                    size="large"
                    title={cardTitle}
                    bodyStyle={{ padding: 0 }}
                    extra={<Link to="/yxxc" onClick={this.props.changeAutoPageShow}>返回迎新现场</Link>}>
                    <div style={{ borderBottom: '1px solid #e8e8e8' }}>
                        {steps}
                    </div>
                    <Card title="个人信息" bordered={false}>
                        <Row className={styles.personal}>
                            <Col xl={3} lg={6} md={12} sm={24} xs={24}>
                                <img
                                    src={`api/sm-student/openapi/getStudentPhoto?xsid=${studentData.XSID}&type=10&uuid=${createUuid()}`}
                                    onError={e => {
                                        e.target.src = defaultPortrait
                                    }}
                                    style={{ width: 125, height: 150 }} />
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>姓 名：</span>{studentData.XM}</div>
                                <div><span>性 别：</span>{studentData.XB}</div>
                                <div><span>民 族：</span>{studentData.MZ}</div>
                                <div><span>学 院：</span>{studentData.BMMC}</div>
                                <div><span>班 级：</span>{studentData.BJMC}</div>
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>身份证号：</span>{studentData.SFZJH}</div>
                                <div><span>出生日期：</span>{studentData.CSRQ}</div>
                                <div><span>学生类型：</span>{studentData.XSLB}</div>
                                <div><span>专业名称：</span>{studentData.ZYMC}</div>
                                <div><span>宿舍信息：</span>{studentData.SSXQMC}-{studentData.LDMC}-{studentData.LCMC}-{studentData.FJMC}{studentData.CWH ? '-' + studentData.CWH : studentData.CWH}</div>
                            </Col>
                            <Col xl={7} lg={12} md={12} sm={24} xs={24}>
                                <div><span>生源地：</span>{studentData.SYD}</div>
                                <div><span>联系电话：</span>{studentData.SJHM}</div>
                            </Col>
                        </Row>
                        <div>
                            {lchjData.hjdm == "GD007_1" ?
                             <Jxfzcmxx location={location} studentData={studentData}
                                          hjblztData={hjblztData} 
                                          lchjData={lchjData} 
                                          loading={loading} /> :
                                          <Card type="inner" title={lchjData && lchjData.hjmc ? `${lchjData.hjmc}业务信息` : '业务信息'}>
                                          <Form>
                                              {formItems}
                                          </Form> 
                                      </Card>
                            } 
                           
                            <Divider style={{ margin: '40px 0 24px' }} />
                            {
                                hjblztData.blzt == '0' ?
                                    (hasAuth('zhxg_yxgl_yxxc:submit') ? <Button type="primary" onClick={this.props.autoHandleSubmit} loading={loading}>确认办理</Button>:null)
                                    : (hasAuth('zhxg_yxgl_yxxc:cancel') ?<Button type="primary" onClick={this.props.autoHandleCancel} loading={loading}>取消办理</Button>:null)
                            }
                             

                        </div>
                    </Card>
                </Card>
            </div>
        );
    }
}

const AutoHandleForm = Form.create()(AutoHandleFormPage);
export default AutoHandleForm;

AutoHandleFormPage.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //学生环节办理状态信息
    lchjData:PropTypes.object,   //学生办理环节信息
    loading:PropTypes.string,  //是否加载中
    lcpz: PropTypes.object, //流程配置信息
    changeAutoPageShow:PropTypes.func,  //自动办理页面是否显示方式
    autoHandleSubmit:PropTypes.func,   //自动办理提交方法
    autoHandleCancel:PropTypes.func, //自动办理取消方法
}


// WEBPACK FOOTER //
// ./components/yxxc/autoHandle/autoHandleForm.js